import { Link } from "react-router-dom";
import "../../../styles/weatherPublicPages.css";

const WeatherPublicLayout = ({ title, children }) => (
  <div className="weather-public-layout">
    <header className="weather-public-header">
      <div>
        <Link to="/">Midpoint</Link>
        <div className="weather-public-disclaimer">{title || "Weather intelligence"}</div>
      </div>
      <nav>
        <Link to="/weather/sources">Weather sources</Link>
      </nav>
    </header>
    <main className="weather-public-main">{children}</main>
  </div>
);

export default WeatherPublicLayout;
